import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { toast } from "react-toastify";
import api from "../../config";
import { showMessageError } from "../../classes/functions";

export default function TablePagination({page, limitPage, pesquisa_status, termSearch, qtdePage, setCarrying, setList, setTotal, setPage, setQtdePage, setLimitPage, API, params}){
    function nextPage () {
        if (limitPage != page) {
          setCarrying(true);
          
          let data = {data: Object.assign({}, params, {
            termSearch: termSearch,
            status: pesquisa_status,
            page: page+1,
            qtdePage: qtdePage,
          })};
          
          api.post(API, data)
          .then((response) => {
            setList(response.data.dados);
            setTotal(response.data.qtde);
            setCarrying(false);
            
            setPage(page+1);
            setQtdePage(qtdePage);
          }
          ).catch((error) => {
            showMessageError(error.response.data);
            setCarrying(false);
          });
        }
      }
    
      function lastPage () {
        if (limitPage != page) {
          setCarrying(true);
    
          let data = {data: Object.assign({}, params, {
              termSearch: termSearch,
              status: pesquisa_status,
              page: limitPage,
              qtdePage: qtdePage,
          })};
    
          api.post(API, data)
          .then((response) => {
              setList(response.data.dados);
              setTotal(response.data.qtde);
              setCarrying(false);
    
              setPage(limitPage);
              setQtdePage(qtdePage);
            }
          ).catch((error) => {
            showMessageError(error.response.data);
            setCarrying(false);
          });
        }
      }
    
      function firstPage () {
        if (page != 1) {
          setCarrying(true);
    
          let data = {data: Object.assign({}, params, {
              termSearch: termSearch,
              status: pesquisa_status,
              page: 1,
              qtdePage: qtdePage,
            })};
          
    
          api.post(API, data)
          .then((response) => {
              setList(response.data.dados);
              setTotal(response.data.qtde);
              setCarrying(false);
    
              setPage(1);
              setQtdePage(qtdePage);
            }
          ).catch((error) => {
            showMessageError(error.response.data);
            setCarrying(false);
          });
        }
      }
    
      function previewPage () {
        if (page != 1) {
          setCarrying(true);
    
          let data = {data: Object.assign({}, params, {
              termSearch: termSearch,
              status: pesquisa_status,
              page: page-1,
              qtdePage: qtdePage,
          })};
    
          api.post(API, data)
          .then((response) => {
              setList(response.data.dados);
              setTotal(response.data.qtde);
              setCarrying(false);
    
              setPage(page-1);
              setQtdePage(qtdePage);
            }
          ).catch((error) => {
            showMessageError(error.response.data);
            setCarrying(false);
          });
        }
      }

    return (
        <div className="divGroupPagination">
            <button data-tip="Primeira página" type="button" onClick={firstPage} className="buttonFirstPage"><FaArrowLeft color="#001675" size={17} /><FaArrowLeft color="#001675" size={17} /></button>
            <button data-tip="Página anterior" type="button" onClick={previewPage} className="buttonPreviewPage"><FaArrowLeft color="#001675" size={17} /></button>
            <div className="divLabelPagination">
              <center><label className="labelPage">Exibindo página {page} de {limitPage}</label></center>
            </div>
            <button data-tip="Próxima página" type="button" onClick={nextPage} className="buttonNextPage"><FaArrowRight color="#001675" size={17} /></button>
            <button data-tip="Última página" type="button" onClick={lastPage} className="buttonLastPage"><FaArrowRight color="#001675" size={17} /><FaArrowRight color="#001675" size={17} /></button>
        </div>
    )
}